import { TableSettings } from '../interfaces/table-settings.model';

export const removeNullOrUndefinedValues = (obj: TableSettings<string | boolean | string[]>) => {
    const newObj = {};
    Object.keys(obj).forEach(key => {
        // @ts-ignore
        if (obj[key] !== null && obj[key] !== undefined) {
            // @ts-ignore
            newObj[key] = obj[key];
        }
    });

    return newObj;
};
